import { Trans } from "react-i18next"

export default function PollClosed({ context }) {
  return (
    <Trans
      i18nKey="notifications.pollClosed"
      values={{ poll: context?.pollName || "Deleted" }}
      components={{ b: <b /> }}
    />
  )
}
